export const createKeywords = (str) => {
  let arr = [];
  str.split(" ").forEach((word) => {
    const string = word.trim().replace(/ +(?= )/g, "");
    for (let i = 0; i < string.trim().length; i++) {
      arr.push(string.substr(0, i + 1).toLowerCase());
    }
  });

  const string = str.trim().replace(/ +(?= )/g, "");
  for (let i = 0; i < string.trim().length; i++) {
    arr.push(string.substr(0, i + 1).toLowerCase());
  }

  // remove duplicated words
  arr = arr.filter((item, index) => arr.indexOf(item) === index);
  return arr;
};
